import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmCustomQueueCalendarRoute: InvariantJiraRoute = {
	name: 'csm-queues-custom-calendar',
	path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
	exact: true,
};
